import React, { useEffect, useState } from "react";
import { listPendingSites } from "../../services/siteManagement/siteManagement.service";
import LoadingSpinner from '../ui/LoadingSpinner';

const PendingSitesCard: React.FC = () => {
    const [count, setCount] = useState<number | null>(null);

    useEffect(() => {
        let mounted = true;
        const fetchCount = async () => {
            try {
                const res = await listPendingSites();
                if (!mounted) return;
                if (res?.success && Array.isArray(res.data)) {
                    setCount((res.data as any[]).length);
                } else {
                    setCount(0);
                }
            } catch (e) {
                // preserve previous console behavior
                // eslint-disable-next-line no-console
                console.info('Failed to load pending sites count', e);
                if (mounted) setCount(0);
            }
        };

        void fetchCount();
        return () => { mounted = false; };
    }, []);

    const display = count === null ? null : new Intl.NumberFormat().format(count);

    // While loading, show a card with the spinner centered (like AdminUserActivity)
    if (count === null) {
        return (
            <div className="card">
                <div className="card__content">
                    <LoadingSpinner message="Loading…" />
                </div>
            </div>
        );
    }

    return (
        <div className="card card__pending-alarms">
            <div className="card__icon--alarm" />
            <div className="card__content">
                <h6>Pending</h6>
                <h2>{display}</h2>
                <span>Pending Sites</span>
            </div>
        </div>
    );
};

export default PendingSitesCard;